<template>
  <el-form ref="search" inline :model="search" size="mini">
    <el-form-item>
      <el-date-picker
          v-model="search.date_lives"
          type="monthrange"
          range-separator="至" value-format="yyyy-MM"
          start-placeholder="开始月份"
          end-placeholder="结束月份">
      </el-date-picker>
    </el-form-item>
    <el-form-item>
      <el-input v-model="search.order_no" clearable placeholder="搜索全案订单号" @change="handelSearch"/>
    </el-form-item>
    <el-form-item>
      <select-platform :value.sync="search.platform" @change="handelSearch"/>
    </el-form-item>
    <el-form-item>
      <el-select v-model="search.status" placeholder="搜索状态" clearable @change="handelSearch">
        <el-option v-for="(item,value) in MapStatus" :key="value" :label="item.label" :value="value"/>
      </el-select>
    </el-form-item>
    <el-form-item>
      <select-artist :value.sync="search.artist_id" @change="handelSearch"/>
    </el-form-item>
    <el-form-item>
      <el-input v-model="search.shop_name" clearable placeholder="搜索店铺" @change="handelSearch"/>
    </el-form-item>
    <el-form-item>
      <el-input v-model="search.product_name" clearable placeholder="搜索商品" @change="handelSearch"/>
    </el-form-item>
    <el-form-item>
      <el-input v-model="search.source_traffic" clearable placeholder="搜索流量来源" @change="handelSearch"/>
    </el-form-item>
    <div>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="handelSearch">查询</el-button>
        <template v-if="$route.name==='OrderLiveGuaranteeList'">
          <live-guarantee-import v-permission="'live_guarantee__import'" @close="handelSearch"/>
          <export-by-page v-permission="'live_guarantee__export_pool'" module="LIVE_GUARANTEE_POOL" type="text"
                          :search="search"/>
        </template>
      </el-form-item>
      <el-form-item style="float: right">
        <slot/>
      </el-form-item>
    </div>
  </el-form>
</template>
<script>
import {MapStatus} from "../index";
import SelectArtist from "../../../../components/Selects/artist.vue";
import SelectPlatform from "../../../../components/Selects/platform.vue";
import moment from "moment";
import LiveGuaranteeImport from "./import.vue";
import ExportByPage from "../../../../components/export/ByPage/index.vue";

const lastMonth = moment().subtract(1, 'months').format('YYYY-MM')
export default {
  name: 'LiveGuaranteeSearch',
  components: {ExportByPage, LiveGuaranteeImport, SelectPlatform, SelectArtist},
  data() {
    return {
      MapStatus,
      search: {
        date_lives: [lastMonth, lastMonth],
        date_check: null,
        shop_name: null,
        artist_id: null,
        product_name: null,
        source_traffic: null,
        order_no: null,
        status: null
      }
    }
  },
  watch: {
    "search.date_lives": {
      immediate: true,
      handler() {
        this.search.date_live_rang = null
        if (Array.isArray(this.search.date_lives) && this.search.date_lives.length === 2) {
          this.search.date_live_rang = [
            moment(this.search.date_lives[0]).startOf('month').format('YYYY-MM-DD'),
            moment(this.search.date_lives[1]).endOf('month').format('YYYY-MM-DD'),
          ]
        }
        this.$emit('search')
      }
    }
  },
  methods: {
    handelSearch: function () {
      this.$emit('search')
    },
    getSearch: function () {
      return {...{}, ...this.search}
    }
  }
}

</script>
<style>

</style>
